import { HttpService } from "@/core";
import { generateUuid } from "@/utils";
import {
  SolutionPageReq,
  SolutionPageResp,
  SolutionDetailResp,
  SolutionReq,
  SolutionSimplePageReq,
  SolutionSimplePageResp,
  ListRecord,
} from "./solution.interface";

export class SolutionService {
  static usePageApi() {
    const api = (params: SolutionPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/skill_solution/pageList",
        params,
      });
    return HttpService.usePagination<SolutionPageResp>(api);
  }

  static useSimplePageApi() {
    const api = (params: SolutionSimplePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/skill_solution/pageList",
        params,
      });
    return HttpService.usePagination<SolutionSimplePageResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/skill_solution/${id}`,
      });
    return HttpService.useRequest<SolutionDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: SolutionReq) =>
      HttpService.axios({
        method: "POST",
        url: "/skill_solution/all",
        data,
      });
    return HttpService.useRequest<SolutionDetailResp>(api);
  }

  static useEditApi() {
    const api = (id: string, data: SolutionReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/skill_solution/${id}`,
        data,
      });
    return HttpService.useRequest<SolutionDetailResp>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/skill_solution/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static detailRespToSolutionReq(resp: SolutionDetailResp): SolutionReq {
    const req = new SolutionReq();
    const { projectId, totalBudget, responsibleTenantUserId, remark, list } = resp;
    const _list = list.map((item) => {
      const record = new ListRecord();
      item.uuid = generateUuid();
      record.pick(item);
      return record;
    });
    req.merge({
      projectId,
      totalBudget,
      responsibleTenantUserId,
      remark,
      list: _list,
    });
    return req;
  }
}
